module.exports = __webpack_public_path__ + "fonts/bb2611b.eot";